import { FC } from "react";

import DataSourceView from "./data-source-view";
import DataSourceViewEmpty from "./data-source-view-empty";

interface DataSourceViewOptionalProps {
  dataSourceTitle?: string;
  className?: string;
}

export const DataSourceViewOptional: FC<DataSourceViewOptionalProps> = ({
  dataSourceTitle,
  className,
}: DataSourceViewOptionalProps) => {
  if (!dataSourceTitle) {
    return <DataSourceViewEmpty className={className} />;
  }

  return <DataSourceView dataSourceTitle={dataSourceTitle} />;
};

export default DataSourceViewOptional;
